import { InfoCircleOutlined } from '@ant-design/icons';
import { type LabelTooltipType } from 'antd/es/form/FormItemLabel';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Container = styled.div`
    padding: 0.5rem;
`;

const useCompanyDetailsTooltip = (toolTip: string): LabelTooltipType => {
    useTranslation('companyDetails');

    return {
        title: (
            <Container>
                <Trans
                    components={{
                        br: <br />,
                    }}
                    i18nKey={`companyDetails:${toolTip}`}
                />
            </Container>
        ),
        icon: <InfoCircleOutlined />,
        overlayInnerStyle: { minWidth: '12rem' },
    };
};

export default useCompanyDetailsTooltip;
